import { useHasFeatureAccess, useObjectTypeFeatureByAppSetting } from 'framework-app-settings-features-lib';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useGetHasScope } from 'crm-object-board-core/user';
import { useMemo } from 'react';
export const useHasPerPipelineAccess = () => {
  const objectTypeId = useObjectTypeId();
  const {
    data: feature
  } = useObjectTypeFeatureByAppSetting(objectTypeId, 'crm_object_pipelines', 'cardCustomization');
  const objectHasFeature = useHasFeatureAccess(feature);
  const {
    hasScope,
    loading
  } = useGetHasScope();
  return useMemo(() => {
    if (loading) {
      return false;
    }

    // If the object doesn't support it, no access
    if (!objectHasFeature) {
      return false;
    }

    // No feature entry means no access
    if (!feature) {
      return false;
    }

    // No scopes means no access
    if (!feature.perPipelineAccessScopes || !feature.perPipelineAccessScopes.length) {
      return false;
    }

    // Must have all scopes for access
    return feature.perPipelineAccessScopes.every(scope => hasScope(scope));
  }, [loading, feature, hasScope, objectHasFeature]);
};